<mat-nav-list>
  <button mat-raised-button (click)="onCancel($event)">CANCELAR</button>
  <button mat-raised-button (click)="onConfirm($event)">CONFIRMAR</button>
</mat-nav-list>
